export enum ROLE {
  ADMIN = 'admin',
  COACH = 'coach',
  KID = 'kid',
}
